module.exports = __webpack_public_path__ + "img/desings-segurost.dc19a93c.jpg";